import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0d96a42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "国立国会図書館 送信システム ログイン", -1))
const _hoisted_3 = { class: "content has-background-contents shadow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheNotificationArea = _resolveComponent("TheNotificationArea")!
  const _component_OuterLoginForm = _resolveComponent("OuterLoginForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheNotificationArea, {
      sticky: true,
      messages: _ctx.bannerMessage,
      onRemove: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeBannerMessage($event)))
    }, null, 8, ["messages"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_OuterLoginForm)
      ])
    ])
  ], 64))
}